export default __webpack_public_path__ + "static/media/1331.9a43a8f1.png";